/** Espelha lib/leilao/auction-copy.ts (CentraGF) — mesma copy WPP + página. */

export const AUCTION_PAY_HOURS = 12;
export const APP_AUCTION_LINK = "https://www.suapersonalshopper.vip/auctions";

export function formatAuctionIncrementLabel(increment) {
  if (increment && increment > 0) {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
      maximumFractionDigits: 0,
    }).format(increment);
  }
  return "o valor da tela";
}

export function getAuctionRulesItems(increment) {
  const step = formatAuctionIncrementLabel(increment);
  return [
    "Acesso exclusivo: lances apenas pelo app oficial (link na página)",
    `Incremento: cada lance sobe no mínimo ${step}`,
    "Disputa: não vale dois lances seguidos — espere alguém cobrir",
    "Encerramento: relógio zerou, o maior lance leva",
    `Pagamento: prazo de até ${AUCTION_PAY_HOURS} horas após o arremate`,
    "Sem pagamento no prazo ou desistência, a peça passa imediatamente para a próxima cliente",
  ];
}
